import { SearchModel } from '@internal/blocks/SearchResultsBlock/TSearchParams'
import { translations } from '@internal/i18n/translations'
import { useTranslation } from 'next-i18next'
import { useCallback } from 'react'
import { localeNamespace } from './i18n/Locale'

export const useModelLabel = () => {
  const { t } = useTranslation(localeNamespace.common)

  const getModelLabel = useCallback(
    (model: string, type: SearchModel['type']) => {
      switch (type) {
        case 'fuzzy':
          return t(translations.keywordSearchLabel, { value: model })
        case 'series':
          return t(translations.modelSeries, { model })
      }
      return model
    },
    [t]
  )

  return { getModelLabel }
}
